import styled from "styled-components";

const StyledStepCustomizada =
  styled.div`
      background-color: ${({ $cor }) => $cor};
      width: 20px;
      height: 20px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center; /* Corrigido aqui */
      font-size: 12px;
      color: #fff;
`;

const StepCustomizada = ({active, label}) => {
  return (
    <StyledStepCustomizada $cor= { active ? "#0f2047" : "lightgray" } >
      { label }
    </StyledStepCustomizada>
   );
}

export default StepCustomizada;
